export default __webpack_public_path__ + "static/Ravi-73eb846fa44bac838f02cb98d23c2940.jpg";